import { FC } from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { Button } from '@/atoms/Button'
import { slugs } from '@/constants/slugs'
import { useTranslate } from '@/utils/translate/translate-client'
import { GButtonMD } from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'
import { useGiveawayContext } from '@/views/PreSales/PreSalesGiveawayView/context/GiveawayContext'

interface Props {
  onClick: () => void
}

export const FloatingCtaButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslate('tickets')
  const { theatricalSlug } = useGiveawayContext()

  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{
        y: 0,
        opacity: 1,
        transition: { type: 'tween', duration: 0.3 },
      }}
      className="fixed inset-x-0 bottom-0 z-50 bg-black p-6 md:hidden"
      style={{
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%)',
      }}
    >
      <Button
        onClick={onClick}
        className={classNames(
          'flex w-full flex-col border-none  !py-[17px] md:!px-7',
          theatricalSlug === slugs.sketch ? 'rounded-none' : 'rounded-xl',
          theatricalSlug === slugs.david ? 'bg-giveaway-primary-subtle' : 'bg-giveaway-secondary',
          theatricalSlug === slugs.iWasAStranger && '!bg-giveaway-secondary-accent',
        )}
        variant="core-gray-900"
      >
        <GButtonMD color="white">{t('preOrderTicketsV2', 'Preorder Tickets')}</GButtonMD>
      </Button>
    </motion.div>
  )
}
